/* eslint-disable class-methods-use-this */
/* eslint-disable no-invalid-this */

const React = require('react');
const wrapUFE = require('utils/framework/wrapUFE');
const genericShouldComponentUpdate = require('utils/framework/wrapComponentRender').shouldComponentUpdate;

class BaseClass extends React.Component {

    constructor(props) {
        super(props);
    }
    
    shouldComponentUpdate = genericShouldComponentUpdate;
}

BaseClass.class = 'BaseClass';

module.exports = BaseClass;
